import React, { useState, useLayoutEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import { Passaggio } from '../App';
import Swal from 'sweetalert2';
import '../Locali/Locali.css'

const Locali = () => {
    const link = useNavigate()
    const { url } = useContext(Passaggio);
    const [locali, setlocali] = useState([])
    let vettoreLocali = []
    useLayoutEffect(() => {
        controllaToken()
        ScaricaLocali();
    }, [])
    const controllaToken = () => {


        fetch(url+"/contolloToken", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + sessionStorage.getItem("token")
            }
        })
            .then(response => response.json())
            .then((dati) => {
                if (dati.risultato=="ko" || dati.risultato==undefined) {
                    Swal.fire({ title: 'Login fallito. Riprova.', icon: 'warning', timer: 1500, showConfirmButton: false });
                    link("/")
                }

            })
    }
    const passaCibi = (id) => {
        //Passo id del locali alla funzione e lo salvo in sessionStorage
        // Contesto.setidLocale(id)
        sessionStorage.setItem('idLocale', id)
        link("/cibi")
    }
    //Fetch per scaricare i locali
    const ScaricaLocali = () => {
        //Grazie all'ID che ho salvato nel sessionStorage, posso costruire l'URL per collegarmi alla pagina dei locali corrispondente alla città corretta
        
        fetch(url + "/getLocali?citta=" + sessionStorage.getItem('idCitta'))
            .then(response => response.json())
            .then(data => {
                vettoreLocali = []
                data.forEach(element => {
                    vettoreLocali.push(
                        //Info relative ai locali
                        <div key={element.id_l} className='pulsante' onClick={() => passaCibi(element.id_l)} >
                            <div className='formattatesto'>
                                {element.nome}
                            </div>
                            <div className='formattainfo'>
                                INDIRIZZO: {element.indirizzo}
                            </div>
                            <div className='formattainfo'>
                                TELEFONO: {element.telefono}
                            </div>
                            <div className='formattainfo'>
                                EMAIL: {element.email}
                            </div>
                            <div className='formattainfo'>
                                GIORNO CHIUSURA: {element.chiusura}
                            </div>
                        </div>
                    )
                });
                setlocali(vettoreLocali)
            })
    }
    //Visualizzo locali
    return (
        <div className="localiPage">
            <div className="log">
                <div className="contenitoreLocali">
                    <div className="headingsContainer">
                        <h1 className="mangiuma-elegant">LOCALI DISPONIBILI</h1>
                        <h2 className='color'>Scegli il locale dove ordinare</h2>
                    </div>
                    <div className="mainContainer localiContainer">
                        {locali}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Locali
